import * as React from 'react';
import { Container, Title, Section, VariantSlider } from '../../modules/modules';
import GoogleTagManagerService from '../../services/GoogleTagManagerService';

import './style.scss';

interface IRecommendedProductsProps {
  variants: GQL.IProductVariant[];
  GTMItemListName?: string;
}

interface IRecommendedProductsState {
  disableArrows?: true;
}

class RecommendedProducts extends React.Component<IRecommendedProductsProps, IRecommendedProductsState> {
  constructor(props: IRecommendedProductsProps) {
    super(props);
    this.state = {};
  }

  public render() {
    GoogleTagManagerService.productsInCategory(this.props.variants, {
      pageType: 'product',
      list: 'recommendedproducts',
      itemListName: 'Recommended products',
    });

    if (Array.isArray(this.props.variants) && this.props.variants.length === 0) {
      return null;
    }

    return (
      <Section type="recommended-products">
        <Container>
          <div className="recommended_products" ref={(element) => {
            if (element && element.clientWidth && ((element.clientWidth / 198) > this.props.variants.length) && !this.state.disableArrows) {
              this.setState({disableArrows: true});
            }
          }}>
            <Title type="center">Recommended products</Title>
            <VariantSlider
              variants={this.props.variants}
              productTags={[]}
              GTMItemListName={this.props.GTMItemListName}
              disableArrows={this.state.disableArrows}
            />
          </div>
        </Container>
      </Section>
    );
  }
}

export default RecommendedProducts;



// WEBPACK FOOTER //
// ./src/components/RecommendedProducts/RecommendedProducts.tsx